module.exports = __webpack_public_path__ + "static/img/banner.9e4b7d69.jpg";